import React from 'react';
import { PlaybookEntry, formatRelativeTime } from '../servicesShared';
import { SectionHeader } from './editorShared';

const text = (value: unknown): string => {
    if (value === null || value === undefined) return '';
    if (typeof value === 'string') return value;
    return JSON.stringify(value);
};

/**
 * The service playbook: every answer your team gave at service scope. Read
 * only here — jobs read it at their next wake; the improvement run proposes
 * folding it into the instructions (OWNED_JOBS_PLAN.md §1 Guidance).
 */
export const PlaybookTab: React.FC<{ entries: PlaybookEntry[] }> = ({ entries }) => (
    <section className="mb-10">
        <SectionHeader
            title="Playbook"
            description="Guidance you answered for every job of this service. Each entry changes what all of its jobs do at their next wake. Fold stable entries into the instructions when they stop changing."
        />
        {entries.length ? (
            <div className="rounded-lg border divide-y">
                {[...entries].reverse().map((entry, index) => (
                    <div key={text(entry.request_id) || index} className="px-3 py-3 space-y-1">
                        {entry.question && <div className="text-sm text-muted-foreground">{text(entry.question)}</div>}
                        <div className="text-sm whitespace-pre-wrap">{text(entry.answer) || text(entry)}</div>
                        <div className="text-xs text-muted-foreground">
                            {entry.answered_at ? formatRelativeTime(text(entry.answered_at)) : ''}
                            {entry.answered_by ? ` · ${text(entry.answered_by)}` : ''}
                        </div>
                    </div>
                ))}
            </div>
        ) : (
            <p className="text-sm text-muted-foreground">
                Empty. When a job asks you a question and you answer it for every job of this service, the answer lands here.
            </p>
        )}
    </section>
);

export default PlaybookTab;
